<template>
    <form :id="formId">
        <VJoyHighlight display-icon accent level="warning" class="highlight">
            <span>{{ t('projectclient.projectview.main.actions.end.project.highlight.principal') }}</span>
            <span v-if="allLotsCompleted">{{ t('projectclient.projectview.main.actions.end.project.highlight.secondary.all-lots-completed') }}</span>
            <span v-else>{{ t('projectclient.projectview.main.actions.end.project.highlight.secondary.lot-completion-required') }}</span>
        </VJoyHighlight>
        <ul v-if="!allLotsCompleted">
            <li>{{ t('projectclient.projectview.main.actions.end.project.info.invoice') }}</li>
            <li>{{ t('projectclient.projectview.main.actions.end.project.info.approval') }}</li>
        </ul>
        <div v-if="!isParticipant && hasAuthorityToEndProject">
            <VJoyHighlight level="warning" accent class="joy-mt-6 joy-mb-6">
                {{ t('projectclient.projectview.main.actions.end.admin.comment.highlight') }}
            </VJoyHighlight>
            <VJoyTextarea
                v-model="adminComment"
                class="joy-mb-4"
                :label="t('projectclient.projectview.main.actions.end.admin.comment.label')"
                :placeholder="t('projectclient.projectview.main.actions.end.admin.comment.placeholder')"
            />
            <VJoyFormError v-if="error">
                {{ t('projectclient.general.forms.errors.required') }}
            </VJoyFormError>
        </div>
    </form>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {VJoyFormError, VJoyHighlight, VJoyTextarea} from '@maltjoy/core-vue';
    import {useProjectInformationStore, useUserStore} from '@/common/stores';

    const {t} = useTranslation();
    const userStore = useUserStore();
    const {roles} = storeToRefs(userStore);

    defineProps<{
        formId: string;
        error?: string;
        allLotsCompleted?: boolean;
    }>();

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);

    // handle admin validation + clientOps section
    const isParticipant = computed(() => projectInformation.value?.participant);
    const hasAuthorityToEndProject = computed(() => roles.value.includes('ROLE_MISSION_VALIDATION'));

    const adminComment = defineModel<string>('adminComment', {required: true});
</script>

<style lang="scss" scoped>
    .highlight {
        display: flex;
        align-items: center;

        span {
            margin-right: 4px;
        }
    }

    ul,
    ul > * {
        padding: 0;
        margin: 0;
    }

    ul {
        padding-left: var(--joy-core-spacing-6);

        li {
            margin-top: var(--joy-core-spacing-6);
        }
    }
</style>
